
import { axiosClient } from './axiosClient';

export const superadminService = {
  stats: () => axiosClient.get('/superadmin/stats/'),

  listProfessionals: (params = {}) => axiosClient.get('/superadmin/professionals/', { params }),
  retrieveProfessional: (id) => axiosClient.get(`/superadmin/professionals/${id}/`),
  createResponsable: (payload) => axiosClient.post('/superadmin/professionals/create-responsable/', payload),
  updateProfessional: (id, payload) => axiosClient.patch(`/superadmin/professionals/${id}/update/`, payload),
  archiveProfessional: (id) => axiosClient.delete(`/superadmin/professionals/${id}/delete/`),
  restoreProfessional: (id) => axiosClient.post(`/superadmin/professionals/${id}/restore/`),
  purgeProfessional: (id) => axiosClient.delete(`/superadmin/professionals/${id}/purge/`),
  deleteProfessional: (id) => axiosClient.delete(`/superadmin/professionals/${id}/delete/`),
  notifyProfessionalsClosure: (payload) => axiosClient.post('/superadmin/professionals/notify-closure/', payload),
  sendCampaign: (payload) => axiosClient.post('/superadmin/campaigns/send/', payload),

  listClients: (params = {}) => axiosClient.get('/superadmin/clients/', { params }),
  retrieveClient: (id) => axiosClient.get(`/superadmin/clients/${id}/`),
  createClient: (payload) => axiosClient.post('/auth/addclient/', payload),
  updateClient: (id, payload) => axiosClient.patch(`/superadmin/clients/${id}/update/`, payload),
  deleteClient: (id) => axiosClient.delete(`/superadmin/clients/${id}/delete/`),

  listAdminUsers: (params = {}) => axiosClient.get('/superadmin/users/', { params }),
  createAdminUser: (payload) => axiosClient.post('/superadmin/users/', payload),
  updateAdminUser: (id, payload) => axiosClient.patch(`/superadmin/users/${id}/update/`, payload),
  deleteAdminUser: (id) => axiosClient.delete(`/superadmin/users/${id}/delete/`),

  listSalons: (params = {}) => axiosClient.get('/superadmin/salons/', { params }),
  retrieveSalon: (salonId) => axiosClient.get(`/superadmin/salons/${salonId}/`),
  getSalonLocationSummary: () => axiosClient.get('/superadmin/salons/location-summary/'),
  retrySalonLocation: (salonId, payload = { force_refresh: false }) =>
    axiosClient.post(`/superadmin/salons/${salonId}/location-repair/`, payload),
  bulkRepairSalonLocations: (payload) =>
    axiosClient.post('/superadmin/salons/location-repair-bulk/', payload),
  applySalonLocation: (salonId, payload) =>
    axiosClient.post(`/superadmin/salons/${salonId}/location-apply/`, payload),
  updateSalon: (id, payload) => axiosClient.patch(`/superadmin/salons/${id}/update/`, payload),
  archiveSalon: (id) => axiosClient.delete(`/superadmin/salons/${id}/delete/`),
  restoreSalon: (id) => axiosClient.post(`/superadmin/salons/${id}/restore/`),
  purgeSalon: (id) => axiosClient.delete(`/superadmin/salons/${id}/purge/`),
  deleteSalon: (id) => axiosClient.delete(`/superadmin/salons/${id}/delete/`),
  getSalonQr: (id) => axiosClient.get(`/salons/${id}/qr/`),
  uploadSalonPhoto: (id, formData) => axiosClient.post(`/superadmin/salons/${id}/photos/upload/`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deleteSalonPhoto: (id, photoId) => axiosClient.delete(`/superadmin/salons/${id}/photos/${photoId}/`),
  setSalonPhotoPrimary: (id, photoId) => axiosClient.post(`/superadmin/salons/${id}/photos/${photoId}/set-primary/`),
  reorderSalonPhotos: (id, photoIds) => axiosClient.post(`/superadmin/salons/${id}/photos/reorder/`, { photo_ids: photoIds }),

  createTeam: (salonId, payload) => axiosClient.post(`/superadmin/salons/${salonId}/teams/create/`, payload),
  updateTeam: (salonId, teamId, payload) => axiosClient.patch(`/superadmin/salons/${salonId}/teams/${teamId}/update/`, payload),
  deleteTeam: (salonId, teamId) => axiosClient.delete(`/superadmin/salons/${salonId}/teams/${teamId}/delete/`),
  createEmployee: (salonId, payload) => axiosClient.post(`/superadmin/salons/${salonId}/employees/create/`, payload),
  updateEmployee: (salonId, memberId, payload) => axiosClient.patch(`/superadmin/salons/${salonId}/employees/${memberId}/update/`, payload),

  getSalonTeam: (salonId) => axiosClient.get('/teams/team-members/salon_members/', { params: { salon: salonId } }),
  deleteTeamMember: (id) => axiosClient.delete(`/teams/team-members/${id}/`),

  getSalonServices: (salonId) => axiosClient.get(`/services/by-category/`, { params: { salon_id: salonId } }),
  getSalonCategories: (salonId) => axiosClient.get('/categories/', { params: { salon: salonId } }),
  retrieveCategory: (id) => axiosClient.get(`/categories/${id}/`),
  getDefaultCategories: () => axiosClient.get('/categories/default/'),
  createCategory: (payload) => axiosClient.post('/categories/', payload),
  updateCategory: (id, payload) => axiosClient.patch(`/categories/${id}/`, payload),
  deleteCategory: (id) => axiosClient.delete(`/categories/${id}/`),
  retrieveService: (id) => axiosClient.get(`/services/${id}/`),
  createService: (payload) => axiosClient.post('/services/', payload),
  updateService: (id, payload) => axiosClient.patch(`/services/${id}/`, payload),
  deleteService: (id) => axiosClient.delete(`/services/${id}/`),

  getSalonHistory: (salonId, params = {}) => axiosClient.get('/audit/logs/', { params: { salon_id: salonId, ...params } }),

  resetUserPassword: (userId) => axiosClient.post(`/superadmin/users/${userId}/reset-password/`),

  // Subscriptions: Plans
  listSubscriptionPlans: (params = {}) => axiosClient.get('/superadmin/subscription-plans/', { params }),
  createSubscriptionPlan: (payload) => axiosClient.post('/superadmin/subscription-plans/', payload),
  updateSubscriptionPlan: (id, payload) => axiosClient.patch(`/superadmin/subscription-plans/${id}/`, payload),
  deleteSubscriptionPlan: (id) => axiosClient.delete(`/superadmin/subscription-plans/${id}/`),

  // Subscriptions: Plan Features
  listSubscriptionFeatures: (planId) => axiosClient.get('/superadmin/subscription-features/', { params: { plan: planId } }),
  createSubscriptionFeature: (payload) => axiosClient.post('/superadmin/subscription-features/', payload),
  updateSubscriptionFeature: (id, payload) => axiosClient.patch(`/superadmin/subscription-features/${id}/`, payload),
  deleteSubscriptionFeature: (id) => axiosClient.delete(`/superadmin/subscription-features/${id}/`),

  // Subscriptions: User Subscriptions
  listSubscriptions: (params = {}) => axiosClient.get('/superadmin/subscriptions/', { params }),
  createSubscription: (payload) => axiosClient.post('/superadmin/subscriptions/', payload),
  updateSubscription: (id, payload) => axiosClient.patch(`/superadmin/subscriptions/${id}/`, payload),
  deleteSubscription: (id) => axiosClient.delete(`/superadmin/subscriptions/${id}/`),
  activateSubscription: (id, data = {}) => axiosClient.post(`/superadmin/subscriptions/${id}/activate/`, data),
  deactivateSubscription: (id) => axiosClient.post(`/superadmin/subscriptions/${id}/deactivate/`),

  listTrialUsers: (params = {}) => axiosClient.get('/superadmin/trial-users/', { params }),
};

